import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { houseNames, isNotTransits } from '@chronos/astro-lib';
import { Group } from './Circle';
import { hideMapInfoPopup, showMapInfoPopup } from './utils';
import { degToString } from '@chronos/api';
import { WITH_OUTER_OFFSET } from './Circle';
function getStyle(props, id, opacity = '1', theme, width = 1) {
    const isMajorCusps = [0, 3, 6, 9].includes(id);
    const isSpec = (props.mode === 'natal') && isMajorCusps;
    const doubleMapWithOutNatal = props.doubleMapWithOutNatal && isMajorCusps;
    const color = (isSpec || doubleMapWithOutNatal && !props.hasOuter)
        ? `rgba(var(--circle-houses-special-rgb-${theme}), ${opacity})`
        : props.isExt
            ? `rgba(var(--circle-houses-alternative-rgb-${theme}), ${opacity})`
            : (isNotTransits(props.mode) && !props.doubleMapWithOutNatal) || props.hasOuter
                ? `rgba(var(--circle-houses-special-rgb-${theme}), ${opacity})`
                : `rgba(var(--circle-houses-usual-rgb-${theme}), ${opacity})`;
    const strokeWidth = isSpec || props.mode === 'horar' && isMajorCusps ? 2 * width : width;
    return { isSpec, color, strokeWidth };
}
export default class Houses extends React.Component {
    constructor(props) {
        super(props);
        this._container = React.createRef();
        this._cusps = [];
        this.update = (newProps) => {
            var _a, _b;
            const { personalization } = newProps.mapSettings;
            const { computedRadius } = newProps;
            const asc = this._container.current.firstChild;
            const mc = this._container.current.lastChild;
            if (newProps.houses.length === 0 && newProps.mode !== 'soul' || newProps.houses.includes(NaN)) {
                asc.style.display = 'none';
                mc.style.display = 'none';
                this._cusps.forEach(c => c.current.style.display = 'none');
                return;
            }
            const housesRadius = newProps.radius * personalization.circle.radius.houses * personalization.circle.houses.length;
            const endRadius = newProps.radius * personalization.circle.radius.cusps * personalization.circle.houses.length;
            const outRadius = newProps.radius * personalization.circle.radius.external;
            const extRadius = newProps.radius * (newProps.hasExt
                ? newProps.isExt
                    ? newProps.hasOuter ? computedRadius.zodiacsInternalExt : computedRadius.external
                    : newProps.hasOuter ? computedRadius.zodiacsInternalExt - (WITH_OUTER_OFFSET * 1.87) : computedRadius.zodiacsInternalExt
                : computedRadius.zodiacsInternal);
            const getInternalRadius = (mode) => {
                switch (mode) {
                    case 'horar': return personalization.circle.radius.internalHorar;
                    case 'soul': return personalization.circle.radius.internalSoul || 0.1;
                    default: return (computedRadius.internal);
                }
            };
            const intRadius = newProps.radius * (newProps.hasExt
                ? newProps.isExt
                    ? (newProps.hasOuter ? computedRadius.internalExt + WITH_OUTER_OFFSET : computedRadius.zodiacsExternalExt)
                    : (newProps.hasOuter ? computedRadius.internalExt - WITH_OUTER_OFFSET : computedRadius.internalExt)
                : getInternalRadius(newProps.mode));
            const updateLine = (l, p1, p2, stroke, strokeWidth) => {
                l.setAttribute('x1', p1.x.toString());
                l.setAttribute('y1', p1.y.toString());
                l.setAttribute('x2', p2.x.toString());
                l.setAttribute('y2', p2.y.toString());
                l.setAttribute('stroke', stroke);
                l.setAttribute('stroke-width', strokeWidth.toString());
            };
            for (let i = 0; i < 12; i++) {
                const lon = ['horar', 'soul'].includes(newProps.mode) ? (newProps.mode === 'soul' ? 0 : 180) + i * 30 : newProps.houses[i];
                const cusp = this._cusps[i].current;
                const endPos = newProps.point(endRadius * (newProps.mode === 'horar' ? 0.95 : 1), lon);
                const outPos = newProps.point(outRadius, lon);
                const extPos = newProps.point(extRadius, lon);
                const intPos = newProps.point(intRadius, lon);
                const { x, y } = newProps.point(housesRadius * (['horar', 'soul'].includes(newProps.mode) ? i == 0 || i == 6 ? 1.025 : 0.975 : 1), lon);
                const opacity = !newProps.highlights || newProps.highlights.includes(i) ? '1' : '0.2';
                const style = getStyle(newProps, i, opacity, personalization.circle.colorThemes.houses.active, personalization.circle.houses.width);
                if (newProps.mode === 'horar' && [0, 3, 6, 9].includes(i)) {
                    style.color = 'var(--text-primary)';
                }
                const house = cusp.lastChild;
                house.onmouseenter = (ev) => {
                    if (newProps.mapSettings.access.limited)
                        return false;
                    const _t = this.props.mapSettings.t;
                    if (newProps.mode === 'soul') {
                        showMapInfoPopup(ev.target, [(_t === null || _t === void 0 ? void 0 : _t("chronos.app.components.circle.year", { count: i * 7 })) || 'no translate'], ev);
                    }
                    else {
                        const text = _t
                            ? _t === null || _t === void 0 ? void 0 : _t("chronos.app.components.circle.house", { house: i + 1, deg: degToString(newProps.houses[i] % 30, { showSeconds: true, isInternational: false }) })
                            : `${i + 1} Дом: ${degToString(newProps.houses[i] % 30, { showSeconds: true, isInternational: false })}`;
                        showMapInfoPopup(ev.target, [text], ev);
                    }
                };
                house.onmouseleave = () => {
                    hideMapInfoPopup();
                };
                house.setAttribute('x', x.toString());
                house.setAttribute('y', y.toString());
                const htext = cusp.childNodes[0];
                const hfirstChild = (_a = house.lastChild) === null || _a === void 0 ? void 0 : _a.firstChild;
                const hlastChild = (_b = house.lastChild) === null || _b === void 0 ? void 0 : _b.lastChild;
                if (newProps.mode === 'horar') {
                    house.setAttribute('color', 'var(--text-secondary)');
                    const name = (() => {
                        switch (i) {
                            case 0: return 'Asc ';
                            case 3: return 'IC ';
                            case 6: return 'Dsc ';
                            case 9: return 'MC ';
                            default: return '';
                        }
                    })();
                    hfirstChild.textContent = `${name}${degToString(newProps.houses[i] % 30, { isInternational: false })}`;
                    if (name) {
                        hfirstChild.style.fontWeight = 'bold';
                        hfirstChild.style.color = 'var(--text-primary)';
                    }
                    hlastChild.style.display = 'none';
                    const { x, y } = newProps.point(intRadius - newProps.radius * 0.04, lon);
                    htext.setAttribute('x', x.toString());
                    htext.setAttribute('y', y.toString());
                    htext.style.display = 'block';
                    htext.textContent = (i + 1).toString();
                }
                else if (newProps.mode == 'soul') {
                    htext.style.display = 'none';
                    hfirstChild.textContent = (i * 7).toString();
                    hlastChild.style.display = 'none';
                }
                else {
                    htext.style.display = 'none';
                    house.setAttribute('color', style.color);
                    hfirstChild.textContent = houseNames[i];
                    hfirstChild.style.fontWeight = 'normal';
                    hfirstChild.style.color = style.color;
                    hlastChild.style.display = 'block';
                    hlastChild.textContent = ` ${Math.ceil(newProps.houses[i] % 30)}`;
                }
                updateLine(cusp.childNodes[1], endPos, outPos, style.color, style.strokeWidth);
                updateLine(cusp.childNodes[2], extPos, intPos, style.color, style.strokeWidth);
                cusp.style.display = 'block';
            }
            if (['horar', 'soul'].includes(newProps.mode)) {
                asc.style.display = 'none';
                mc.style.display = 'none';
                return;
            }
            const ascStyle = getStyle(newProps, 0, '1', personalization.circle.colorThemes.houses.active, personalization.circle.houses.width);
            asc.setAttribute('stroke', ascStyle.color);
            asc.setAttribute('stroke-width', ascStyle.strokeWidth.toString());
            const p = newProps.point(endRadius, newProps.houses[0]);
            const arrowPoint = (angle) => {
                const p = newProps.point(endRadius - newProps.radius * 0.02, newProps.houses[0] + 1.25 * angle);
                return `${p.x} ${p.y}`;
            };
            asc.setAttribute('d', `
      M ${arrowPoint(-1)}
      L ${p.x} ${p.y}
      L ${arrowPoint(1)}
    `);
            const mcStyle = getStyle(newProps, 9, '1', personalization.circle.colorThemes.houses.active, personalization.circle.houses.width);
            const r = newProps.radius * 0.02;
            const o = newProps.point(endRadius - r, newProps.houses[9]);
            mc.setAttribute('r', r.toString());
            mc.setAttribute('cx', o.x.toString());
            mc.setAttribute('cy', o.y.toString());
            mc.setAttribute('stroke', mcStyle.color);
            mc.setAttribute('stroke-width', mcStyle.strokeWidth.toString());
            asc.style.display = 'block';
            asc.style.strokeOpacity = !newProps.highlights || newProps.highlights.includes(0) ? '1' : '0.2';
            mc.style.display = 'block';
            mc.style.strokeOpacity = !newProps.highlights || newProps.highlights.includes(9) ? '1' : '0.2';
        };
        for (let i = 0; i < 12; i++) {
            this._cusps.push(React.createRef());
        }
    }
    componentDidMount() {
        this.update(this.props);
    }
    shouldComponentUpdate(newProps) {
        this.update(newProps);
        return !!newProps.isEditor || newProps.mapSettings.personalization.name !== this.props.mapSettings.personalization.name;
    }
    render() {
        var _a, _b, _c;
        const { props } = this;
        const fontRadius = props.radius * 0.04;
        const houses = [];
        for (let id = 0; id < 12; id++) {
            const style = getStyle(this.props, id, '1', props.mapSettings.personalization.circle.colorThemes.houses.active, props.mapSettings.personalization.circle.houses.width);
            houses.push(_jsxs(Group, { ref: this._cusps[id], onClick: () => props.onHelp('houses', id), id: `house-group-${(_c = (_b = (_a = this.props.mapSettings).t) === null || _b === void 0 ? void 0 : _b.call(_a, houseNames[id])) !== null && _c !== void 0 ? _c : houseNames[id]}`, children: [_jsx("text", { style: {
                            display: 'none',
                            fontSize: fontRadius,
                            fill: 'var(--text-third)',
                            textAnchor: 'middle',
                            alignmentBaseline: 'middle'
                        } }), _jsx("line", { stroke: style.color, strokeWidth: style.strokeWidth }), _jsx("line", { stroke: style.color, strokeWidth: style.strokeWidth, strokeOpacity: 0.5 }), _jsxs("svg", { overflow: "visible", color: style.color, children: [_jsx("circle", { r: fontRadius, fill: "transparent" }), _jsxs("text", { style: {
                                    fontWeight: style.isSpec ? 'bold' : '700',
                                    fontSize: fontRadius,
                                    fill: 'currentColor',
                                    textAnchor: 'middle',
                                    alignmentBaseline: 'middle'
                                }, children: [_jsx("tspan", { children: houseNames[id] }), _jsx("tspan", { style: {
                                            fontWeight: style.isSpec ? 'bold' : 'normal',
                                            fontSize: fontRadius * 0.7,
                                            baselineShift: 'super'
                                        } })] })] })] }, `${props.mode}_${id}`));
        }
        return (_jsxs("g", { ref: this._container, children: [_jsx("path", { fill: "none" }), houses, _jsx("circle", { fill: "var(--workspace-background)" })] }));
    }
}
